import { render, staticRenderFns } from "./FieldType6.vue?vue&type=template&id=3491828a&scoped=true"
import script from "./FieldType6.vue?vue&type=script&lang=js"
export * from "./FieldType6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491828a",
  null
  
)

export default component.exports